var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileinboxPana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.28,470.77l-156,.08a22.75,22.75,0,0,1-22.76-22.73l-.18-351.41a25.92,25.92,0,0,1,25.91-25.94l153.12-.08a23,23,0,0,1,23,23l.19,353.82A23.28,23.28,0,0,1,296.28,470.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,440l-.18-338.39A27.66,27.66,0,0,1,148.16,74l140.34-.08a27.66,27.66,0,0,1,27.68,27.65l.18,338.39a27.66,27.66,0,0,1-27.65,27.68l-140.34.08A27.67,27.67,0,0,1,120.69,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,86.53a2.25,2.25,0,0,1,0-4.5h28.89a2.25,2.25,0,1,1,0,4.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.34,86.54a2.25,2.25,0,1,1,2.24-2.25A2.25,2.25,0,0,1,188.34,86.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.61,86.53a2.25,2.25,0,1,1,2.24-2.25A2.25,2.25,0,0,1,196.61,86.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,86.5a2.25,2.25,0,1,1,2.25-2.24A2.24,2.24,0,0,1,248.34,86.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07,86.51a2.25,2.25,0,1,1,2.25-2.25A2.24,2.24,0,0,1,240.07,86.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,78.51h-27.2a5.94,5.94,0,0,0-5.7,4.26l-2.22,7.62a6.62,6.62,0,0,1-6.37,4.77l-60.26,0a6.65,6.65,0,0,1-6.38-4.76l-2.23-7.62a5.92,5.92,0,0,0-5.7-4.25H146.72a21.61,21.61,0,0,0-21.65,21.56l.18,340.62a21.6,21.6,0,0,0,21.67,21.53l143.25-.07a21.61,21.61,0,0,0,21.65-21.56L311.64,100A21.6,21.6,0,0,0,290,78.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.39,157.63h0a1.34,1.34,0,0,1,1.33,1.33l0,43.33a1.33,1.33,0,0,1-1.32,1.33h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.37,186.08h0a1.37,1.37,0,0,0-1.37,1.37v26.37a1.38,1.38,0,0,0,1.38,1.37h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.35,148h0a1.37,1.37,0,0,0-1.37,1.38v26.36a1.39,1.39,0,0,0,1.38,1.38h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.34,119.49h0a1.19,1.19,0,0,0-1.19,1.19v11.17a1.18,1.18,0,0,0,1.19,1.18h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.33,
    y: 89.6,
    width: 1.39,
    height: 1.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.59,
    y: 88.73,
    width: 1.39,
    height: 2.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.85,
    y: 88.08,
    width: 1.39,
    height: 3.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.11,
    y: 86.82,
    width: 1.39,
    height: 4.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,91.63h-7a.49.49,0,0,1-.5-.49V87.67a.5.5,0,0,1,.49-.5h7a.14.14,0,0,1,.13.13v1.14h.75a.12.12,0,0,1,.12.13v1.66a.13.13,0,0,1-.13.13h-.75V91.5A.12.12,0,0,1,295,91.63Zm-.13-4.21H288a.24.24,0,0,0-.24.24v3.47a.24.24,0,0,0,.24.24h6.84V90.23a.12.12,0,0,1,.12-.12h.75V88.69H295a.12.12,0,0,1-.12-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.34 90.81 288.34 88 294.29 87.99 294.29 89.26 294.29 89.54 294.29 90.81 288.34 90.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,91.37a.51.51,0,1,0-.51.51A.51.51,0,0,0,281.14,91.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.89,90.15l.65.64a1.55,1.55,0,0,1,2.18,0l.65-.65a2.48,2.48,0,0,0-1.74-.72A2.45,2.45,0,0,0,278.89,90.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.63,88a3.92,3.92,0,0,0-2.76,1.14l.65.65a3,3,0,0,1,4.22,0l.65-.65A3.88,3.88,0,0,0,280.63,88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.81,88.07l.65.65a4.43,4.43,0,0,1,3.17-1.32,4.5,4.5,0,0,1,3.17,1.31l.65-.65a5.4,5.4,0,0,0-7.64,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.47,173.7a12.89,12.89,0,1,1-12.78-13A12.89,12.89,0,0,1,163.47,173.7Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.9,163.77c0,.14-12,.16-26.7,0s-26.71-.33-26.71-.48,12-.16,26.71,0S227.91,163.63,227.9,163.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,176c0,.14-21.8.08-48.69-.14s-48.69-.52-48.69-.66,21.8-.08,48.7.14S271.49,175.85,271.49,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41,185.61c0,.14-21.8.08-48.69-.14S174,185,174,184.81s21.79-.08,48.69.14S271.41,185.46,271.41,185.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,161.92c0,.15-4.72.22-10.53.18s-10.52-.21-10.52-.35,4.71-.22,10.53-.17S300.15,161.78,300.15,161.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,175.33l.87,1.8a1.05,1.05,0,0,0,.78.59l2,.3a1,1,0,0,1,.57,1.79l-1.45,1.39a1.07,1.07,0,0,0-.31.93l.33,2a1.06,1.06,0,0,1-1.54,1.1l-1.76-.95a1.06,1.06,0,0,0-1,0l-1.78.92a1,1,0,0,1-1.51-1.12l.35-2a1,1,0,0,0-.29-.93l-1.42-1.41a1.05,1.05,0,0,1,.6-1.79l2-.27a1,1,0,0,0,.79-.57l.9-1.78A1.06,1.06,0,0,1,292,175.33Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16,163.19a2.42,2.42,0,1,1-2.4-2.44A2.42,2.42,0,0,1,242.16,163.19Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.9,139.84c0,.14-41.65-.08-93-.5s-93-.88-93-1,41.64.08,93,.5S310.91,139.7,310.9,139.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,206.46c0,.15-41.66-.08-93-.5s-93-.88-93-1,41.65.08,93,.5S310.36,206.32,310.36,206.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.49,
    cy: 306.61,
    r: 12.89,
    transform: "translate(-173.02 195.51) rotate(-45)",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.81,296.79c0,.14-11.95.16-26.7,0s-26.71-.33-26.71-.48,12-.16,26.71,0S226.82,296.65,226.81,296.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,309c0,.14-21.8.08-48.69-.14s-48.69-.52-48.69-.66,21.8-.08,48.7.14S270.4,308.87,270.4,309Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.32,318.63c0,.14-21.8.08-48.69-.14s-48.69-.52-48.68-.66,21.79-.08,48.69.14S270.32,318.48,270.32,318.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.06,294.94c0,.15-4.71.22-10.53.18s-10.52-.21-10.52-.35,4.71-.22,10.53-.17S299.06,294.8,299.06,294.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.9,308.35l.87,1.8a1.05,1.05,0,0,0,.78.59l2,.3a1,1,0,0,1,.57,1.79l-1.45,1.39a1.07,1.07,0,0,0-.31.93l.33,2a1.06,1.06,0,0,1-1.54,1.1l-1.76-1a1.06,1.06,0,0,0-1,0l-1.78.92a1,1,0,0,1-1.51-1.12l.36-2a1,1,0,0,0-.3-.93l-1.42-1.41a1.05,1.05,0,0,1,.6-1.79l2-.27a1,1,0,0,0,.79-.57l.9-1.78A1.06,1.06,0,0,1,290.9,308.35Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.65,
    cy: 296.19,
    r: 2.42,
    transform: "translate(-98.37 472.56) rotate(-78.76)",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.81,272.86c0,.14-41.65-.08-93-.5s-93-.88-93-1,41.64.08,93,.5S309.82,272.72,309.81,272.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,339.48c0,.15-41-.12-91.59-.6s-91.59-1-91.59-1.12,41,.12,91.6.6S309.27,339.34,309.27,339.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.35,433.22a12.89,12.89,0,1,1-12.79-13A12.9,12.9,0,0,1,161.35,433.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,423.3c0,.14-12,.16-26.71,0s-26.7-.33-26.7-.48,12-.16,26.71,0S225.78,423.16,225.78,423.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,435.53c0,.14-21.8.08-48.68-.14s-48.69-.52-48.69-.66,21.8-.08,48.69.14S269.36,435.38,269.36,435.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,445.13c0,.15-21.8.09-48.68-.13s-48.69-.52-48.69-.66,21.8-.09,48.69.13S269.29,445,269.28,445.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,421.45c0,.14-4.71.22-10.52.17s-10.53-.2-10.53-.34,4.72-.22,10.53-.18S298,421.31,298,421.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,422.72a2.42,2.42,0,1,1-2.4-2.44A2.42,2.42,0,0,1,240,422.72Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.68,
    y: 205.71,
    width: 185.45,
    height: 66.62,
    transform: "translate(1.96 -1.78) rotate(0.47)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.42,
    cy: 238.8,
    r: 12.89,
    transform: "translate(-124.8 176.31) rotate(-45)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,229c0,.15-12,.17-26.7.05s-26.71-.34-26.71-.48,12-.17,26.71,0S227.74,228.84,227.74,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.33,241.21c0,.15-21.8.08-48.69-.14s-48.69-.51-48.69-.66,21.8-.08,48.69.14S271.33,241.07,271.33,241.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,250.82c0,.14-21.8.08-48.69-.14s-48.69-.51-48.69-.66,21.8-.08,48.7.14S271.25,250.68,271.25,250.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,227.14c0,.14-4.72.22-10.53.17a104.52,104.52,0,0,1-10.52-.35c0-.14,4.71-.22,10.53-.17A104.52,104.52,0,0,1,300,227.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.83,240.55s-.08-.11-.26-.27a1,1,0,0,0-.93-.19.88.88,0,0,0-.53.41c-.13.22-.26.52-.4.81l-.46,1a1.27,1.27,0,0,1-1,.8l-1.29.2-.68.1a.82.82,0,0,0-.49.28.83.83,0,0,0,0,1.09l1.14,1.12.3.29a1.33,1.33,0,0,1,.29.4,1.47,1.47,0,0,1,.07,1q-.15.85-.3,1.74a.79.79,0,0,0,.74,1c.23,0,.44-.12.74-.27l.85-.43a4.41,4.41,0,0,1,.92-.42,1.39,1.39,0,0,1,1.06.22l1.6.86a.81.81,0,0,0,1.11-.43,1.23,1.23,0,0,0,0-.71c0-.28-.08-.55-.13-.82l-.12-.81a1.29,1.29,0,0,1,.17-.92,4.18,4.18,0,0,1,.57-.6l.55-.51.52-.49a.91.91,0,0,0,.28-.48.87.87,0,0,0-.42-.91,5.75,5.75,0,0,0-1.1-.24l-1-.18a1.23,1.23,0,0,1-.87-.48,5.79,5.79,0,0,1-.35-.72,7.34,7.34,0,0,1-.53-1.34,8.31,8.31,0,0,1,.72,1.25,6.06,6.06,0,0,0,.36.66,1,1,0,0,0,.72.34l1,.14a4.81,4.81,0,0,1,1.22.25,1.25,1.25,0,0,1,.26,2l-.52.5-.53.53a3.28,3.28,0,0,0-.49.51.88.88,0,0,0-.1.6c.05.27.09.54.14.81s.09.54.14.82a1.69,1.69,0,0,1,0,1,1.3,1.3,0,0,1-1.8.71l-1.61-.86a.91.91,0,0,0-.72-.17,5.8,5.8,0,0,0-.79.37l-.84.43-.43.22a1.24,1.24,0,0,1-.57.11,1.32,1.32,0,0,1-1.23-1.57c.11-.59.22-1.17.32-1.73a1,1,0,0,0,0-.69,2,2,0,0,0-.49-.56L285.45,245a1.29,1.29,0,0,1,0-1.68,1.26,1.26,0,0,1,.75-.4l.69-.09,1.3-.16a.94.94,0,0,0,.77-.59l.49-.94c.16-.29.29-.55.45-.82a1.14,1.14,0,0,1,.69-.47,1.08,1.08,0,0,1,1.05.32C291.81,240.4,291.84,240.54,291.83,240.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,228.41a2.42,2.42,0,1,1-2.4-2.44A2.43,2.43,0,0,1,242,228.41Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.82,
    y: 338.52,
    width: 185.45,
    height: 66.62,
    transform: "translate(3.05 -1.78) rotate(0.47)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.56,
    cy: 371.61,
    r: 12.89,
    transform: "translate(-218.67 215.3) rotate(-45)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.88,361.79c0,.14-12,.16-26.7,0s-26.71-.33-26.71-.48,12-.16,26.71,0S227.88,361.65,227.88,361.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47,374c0,.14-21.8.08-48.69-.14s-48.69-.52-48.69-.66,21.8-.08,48.69.14S271.47,373.87,271.47,374Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.39,383.63c0,.14-21.8.08-48.69-.14S174,383,174,382.83s21.8-.08,48.7.14S271.39,383.48,271.39,383.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.13,359.94c0,.15-4.72.22-10.53.18s-10.52-.21-10.52-.35,4.71-.22,10.53-.17S300.13,359.8,300.13,359.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,373.35s-.08-.11-.26-.26a1,1,0,0,0-.93-.2.92.92,0,0,0-.53.41c-.13.23-.26.53-.4.82s-.3.62-.46.95a1.26,1.26,0,0,1-1,.81l-1.29.19-.68.11a.82.82,0,0,0-.48,1.37l1.14,1.11.3.29a1.26,1.26,0,0,1,.29.41,1.4,1.4,0,0,1,.07,1q-.15.86-.3,1.74a.78.78,0,0,0,.74.95,1.41,1.41,0,0,0,.74-.26l.85-.44a5,5,0,0,1,.92-.42,1.43,1.43,0,0,1,1.06.23l1.6.86a.81.81,0,0,0,1.11-.43,1.23,1.23,0,0,0,0-.71c0-.28-.08-.56-.13-.83l-.12-.8a1.28,1.28,0,0,1,.17-.92,4.18,4.18,0,0,1,.57-.6l.55-.51.52-.5a.85.85,0,0,0,.28-.48.86.86,0,0,0-.42-.9,5.08,5.08,0,0,0-1.1-.24l-1-.18a1.24,1.24,0,0,1-.87-.49,5.73,5.73,0,0,1-.35-.71,6.94,6.94,0,0,1-.53-1.35,8.88,8.88,0,0,1,.72,1.26,5.93,5.93,0,0,0,.36.65,1,1,0,0,0,.72.35l1,.14A5.23,5.23,0,0,1,296,376a1.24,1.24,0,0,1,.64,1.3,1.27,1.27,0,0,1-.38.72l-.52.5-.53.52a3.81,3.81,0,0,0-.49.52.87.87,0,0,0-.1.6c.05.27.09.53.14.8s.09.55.14.83a1.77,1.77,0,0,1,0,1,1.32,1.32,0,0,1-1.81.7c-.53-.28-1.07-.56-1.61-.86a1,1,0,0,0-.72-.17,6,6,0,0,0-.79.38l-.84.43-.43.22a1.37,1.37,0,0,1-.57.1,1.32,1.32,0,0,1-1.23-1.56c.11-.59.22-1.17.32-1.74a1,1,0,0,0,0-.69,2.35,2.35,0,0,0-.49-.56l-1.14-1.15a1.29,1.29,0,0,1,0-1.68,1.33,1.33,0,0,1,.75-.41l.69-.09,1.3-.16a.91.91,0,0,0,.77-.58l.49-.94c.16-.3.29-.56.45-.82a1.12,1.12,0,0,1,.69-.48,1.1,1.1,0,0,1,1,.32C292,373.21,292,373.35,292,373.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,361.21a2.42,2.42,0,1,1-2.4-2.44A2.42,2.42,0,0,1,242.14,361.21Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.34,
    y: 115.07,
    width: 20.04,
    height: 16.18,
    rx: 2.25,
    transform: "translate(1.02 -1.78) rotate(0.47)",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.35,115.76a3.82,3.82,0,0,1-.62.84c-.42.52-1,1.26-1.83,2.17l-2.76,3.17-1.65,1.86a13.28,13.28,0,0,1-.91,1,2,2,0,0,1-1.45.45,2,2,0,0,1-1.33-.71l-.89-1-1.67-1.84-2.8-3.13c-.8-.9-1.43-1.63-1.86-2.15a4,4,0,0,1-.63-.83s.3.22.78.7,1.15,1.16,2,2l2.88,3.06,1.7,1.82.89,1a1.46,1.46,0,0,0,2.07.21c.27-.24.58-.63.86-.93l1.67-1.84,2.85-3.1c.81-.87,1.48-1.58,2-2A4.11,4.11,0,0,1,227.35,115.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.31,123.09a29.55,29.55,0,0,1-3.21,3.63,18.53,18.53,0,0,1-3.6,3.27,29.34,29.34,0,0,1,3.22-3.63A18.66,18.66,0,0,1,215.31,123.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.32,130.37a25.13,25.13,0,0,1-3.71-3.65,27,27,0,0,1-3.34-4,25.46,25.46,0,0,1,3.72,3.65A26.54,26.54,0,0,1,228.32,130.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,121.64c0,.09-3.42.16-7.64.16s-7.64-.07-7.64-.16,3.42-.16,7.64-.16S153.77,121.55,153.77,121.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,125.55c0,.09-3.42.16-7.64.16s-7.64-.07-7.64-.16,3.42-.16,7.64-.16S153.77,125.46,153.77,125.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,129.46c0,.09-3.42.17-7.64.17s-7.64-.08-7.64-.16,3.42-.17,7.64-.17S153.77,129.38,153.77,129.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.18,124.13c-.05,0,0-.38-.22-1a4.13,4.13,0,0,0-1.52-2.21,4,4,0,1,0-.05,6.41,4.26,4.26,0,0,0,1.56-2.19c.18-.63.18-1,.23-1a.94.94,0,0,1,0,.27,3.17,3.17,0,0,1-.08.78,4.22,4.22,0,0,1-1.54,2.41,4.4,4.4,0,1,1,.06-7,4.18,4.18,0,0,1,1.49,2.44,3,3,0,0,1,.07.78A.68.68,0,0,1,297.18,124.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.43,131.39a8.25,8.25,0,0,1-2-1.89,8.33,8.33,0,0,1-1.69-2.21,8.25,8.25,0,0,1,2,1.89A8.16,8.16,0,0,1,299.43,131.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.81,333l-.14,53.74-23.75-4.88-20-4.18s27.38,54,57.16,54,33.63-44.93,33.63-44.93L336.48,333Z",
    style: {
      fill: "#9b7564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.18,194.37C409,195.61,406,194,405,191.68s-.54-5,.22-7.44,1.82-4.78,2-7.31a10.78,10.78,0,0,0-7.24-10.6c4.3-3.41,4.65-10.72.7-14.53-1.85-1.78-4.31-2.75-6.46-4.15a22,22,0,0,1-3.4-2.77,14,14,0,0,0,5.86.18,9.5,9.5,0,0,0,6.88-6,8.59,8.59,0,0,0-2.08-8.81,7.88,7.88,0,0,0-8.86-1.32c-2.78,1.47-4.3,4.49-5.65,7.33l-1.26,2.63c-3.91-5.18-7.59-10.53-13.62-12.35-5.47-1.65-11.35.19-17.05-.22-4.15-.31-8.13-1.8-12.27-2.26s-8.85.43-11.29,3.8c-1.44,2-1.89,4.54-3.34,6.51-3,4.06-9.46,4.61-11.92,9-2,3.58-.46,8.1-1.32,12.11-.93,4.36-4.53,7.55-7.47,10.9s-5.51,7.95-3.86,12.09c1.46,3.65,5.71,5.61,7.09,9.28,1,2.68.28,5.65.23,8.51s1.09,6.26,3.88,6.91l31.73,8.38c10.93,4.44,22.2,9,34,8.94s24.39-5.68,29-16.52a6.76,6.76,0,0,1-4.55-2A11.37,11.37,0,0,0,411.18,194.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.17,204.32c2.62-8,5.2-16.15,6.39-24.53s.94-17.12-2-25c-.44-1.2-4.25-9.27-5.53-9.14-.91.09,1.43,7.61,1,8.41-4.4,7.56-5.6,16.65-4.89,25.38a114.35,114.35,0,0,0,5.07,24.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.15,274.66c13.12-.28,28-29,28-29L386,172c.68-21.21-11.09-39.29-32.31-39.39l-2,.1a38,38,0,0,0-35.91,36.86c-.49,18.39-.81,38.72-.16,48.54,1.34,20.32,21.85,22.39,21.85,22.39s.12,4.72.18,10.7c.14,13.42,14.19,23.88,19.45,23.43Z",
    style: {
      fill: "#9b7564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.52,240.53s12.86.07,26.06-9.25c0,0-5.66,15.14-26.05,14.4Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.61,185.56a2.91,2.91,0,0,0,3,2.78,2.78,2.78,0,0,0,2.85-2.77,2.91,2.91,0,0,0-3-2.79A2.78,2.78,0,0,0,324.61,185.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.63,177.81c.38.36,2.49-1.39,5.62-1.55s5.5,1.29,5.82.88c.15-.17-.25-.84-1.29-1.51a7.91,7.91,0,0,0-4.68-1.17,7.68,7.68,0,0,0-4.45,1.7C320.73,177,320.44,177.65,320.63,177.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,184.81a2.91,2.91,0,0,0,3,2.78,2.78,2.78,0,0,0,2.85-2.78,2.91,2.91,0,0,0-2.95-2.78A2.79,2.79,0,0,0,352.76,184.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.31,177.43c.38.36,2.5-1.38,5.62-1.54s5.5,1.28,5.82.88c.16-.18-.24-.84-1.29-1.52a8,8,0,0,0-4.68-1.17,7.71,7.71,0,0,0-4.45,1.7C351.42,176.57,351.13,177.27,351.31,177.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,202.05c0-.18-2-.41-5.13-.64-.8,0-1.56-.16-1.73-.7a4,4,0,0,1,.41-2.39q1-3,2-6.21c2.82-8.82,4.81-16.07,4.45-16.18s-2.93,7-5.74,15.79c-.67,2.17-1.32,4.25-1.93,6.23a4.61,4.61,0,0,0-.25,3.16,2,2,0,0,0,1.38,1.09,5.25,5.25,0,0,0,1.36.12C339.42,202.32,341.38,202.23,341.39,202.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.7,203.72c-.51,0-.33,3.39-3.11,5.95s-6.4,2.39-6.4,2.86c0,.22.84.62,2.36.58a8.47,8.47,0,0,0,5.36-2.2,7.37,7.37,0,0,0,2.39-5C351.36,204.51,350.93,203.69,350.7,203.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8,164.74c.36.84,3.46.27,7.15.51s6.71,1.09,7.15.3c.2-.38-.36-1.15-1.6-1.91a12.46,12.46,0,0,0-10.89-.61C351.29,163.64,350.65,164.35,350.8,164.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.36,167.35c.59.68,2.71-.17,5.29-.34s4.81.22,5.27-.55c.21-.37-.18-1.07-1.17-1.69a7.69,7.69,0,0,0-8.51.72C321.36,166.27,321.1,167,321.36,167.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.15,187.18c.34-.17,13.75-4.88,14.06,9s-13.75,11.35-13.78,11S385.15,187.18,385.15,187.18Z",
    style: {
      fill: "#9b7564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.57,201.82c.06,0,.25.16.66.34a2.42,2.42,0,0,0,1.81,0c1.46-.57,2.65-2.94,2.67-5.45a8.14,8.14,0,0,0-.76-3.46,2.81,2.81,0,0,0-1.86-1.82,1.24,1.24,0,0,0-1.42.7c-.18.39-.08.67-.16.69s-.3-.23-.2-.8a1.57,1.57,0,0,1,.53-.89,1.78,1.78,0,0,1,1.33-.38,3.41,3.41,0,0,1,2.58,2.1,8.2,8.2,0,0,1,.93,3.87c0,2.81-1.41,5.46-3.41,6.09a2.59,2.59,0,0,1-2.23-.32C389.6,202.15,389.52,201.84,389.57,201.82Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,146.41c-2.27-1.21,4.4-8.6,9.91-11.19,8.32-3.9,21.08-6.4,28.82-4.31,9.33,2.51,17.11,7,21.89,15.44s6.66,18.23,6.51,27.89c-.05,2.95-.31,6-1.86,8.54-1.9,3.1-5.61,5.09-5.39,9.34a5.83,5.83,0,0,1-1.39,4.27c-2.52,2.74-5.67.23-7.13-2.3-3.14-5.42-3.56-11.93-3.91-18.17-.25-4.44-.49-9,.71-13.26.65-2.33,1.72-4.54,2.24-6.9s.42-5-1.08-6.95a8.66,8.66,0,0,0-1.14-1.13,14.56,14.56,0,0,0-14.45-2.56c-7.81,2.88-21.15,7.2-24.68,4.58-5.08-3.77-6.32-6.25-6.32-6.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.53,129c-7.68-2.46-16.4-2.21-23.51,1.6-3.78,2-7.18,5.22-8.28,9.35s.72,9.2,4.7,10.76l.28.17c6,1.92,9.82,1.08,15.72-1.05,5-1.79,9.36-4.92,14.33-6.69a28.35,28.35,0,0,1,16.56-.69C376.93,136.47,370.22,131.49,362.53,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,142.8c-.12.1-1.24-1.23-3.5-2.8a20.23,20.23,0,0,0-4.23-2.26,12.94,12.94,0,0,0-5.66-1,19,19,0,0,0-9.71,4c-2.16,1.71-3.16,3.15-3.29,3.05s.15-.43.61-1.07a15.14,15.14,0,0,1,2.25-2.48,18.08,18.08,0,0,1,10.06-4.43,13.29,13.29,0,0,1,6.06,1.08,18.48,18.48,0,0,1,4.3,2.53C388.14,141.23,389.1,142.74,389,142.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41,147.73a11.85,11.85,0,0,1-1.06,4,29,29,0,0,1-13,14.65,11.62,11.62,0,0,1-3.82,1.52c-.17-.27,5.85-2.55,10.9-8.33S390.12,147.6,390.41,147.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.08,150a4.54,4.54,0,0,1,.05,1.58,24.37,24.37,0,0,1-.6,4.28,29.13,29.13,0,0,1-18.1,20.77,24.87,24.87,0,0,1-4.16,1.18,4.4,4.4,0,0,1-1.58.16c0-.16,2.19-.54,5.49-2a30.65,30.65,0,0,0,17.71-20.32C395.83,152.23,395.91,150,396.08,150Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,127.75c0,.16-1.45.5-3.69,1.39a30.24,30.24,0,0,0-14.29,11.78,37.69,37.69,0,0,1-2.07,3.35,10.77,10.77,0,0,1,1.5-3.69,26.55,26.55,0,0,1,6.2-7.39,26.17,26.17,0,0,1,8.44-4.66A11.19,11.19,0,0,1,346.58,127.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.45,129.5c.23,0-.38,4-3.53,7.75s-7,5.05-7,4.82,3.37-1.86,6.31-5.42S400.17,129.41,400.45,129.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.46,378.13l8.26-5.07a9,9,0,0,1,4.65-1.31h16l16.52,15.05,4.93,2.46-1.84,26-10.74-1.32s-22.93,1-25.15-.49-5.43-6.17-5.43-6.17-12.57-4.07-13.8-5.17c-4.67-4.19-2.79-5.19-2.79-5.19l-2.15-1c-.4.76-3.53-4.34-3.2-6.9.19-1.49-.25-1.48-.25-1.48a8.22,8.22,0,0,1-4-5.69c-.23-1.52,6-.43,6-.43l15.53.21Z",
    style: {
      fill: "#9b7564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.27,381.28l-14.61-19.89a5.68,5.68,0,0,0-4.6-2.33H218.18a2.1,2.1,0,0,0-2.1,2.1h0a2.15,2.15,0,0,0,.51,1.37l16.55,19.2h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.19,389.43a12.54,12.54,0,0,1-3.26.43,55,55,0,0,1-15.76-1.36,12.76,12.76,0,0,1-3.14-1,20,20,0,0,1,3.24.49c2,.35,4.73.78,7.79,1s5.84.32,7.85.31A18.57,18.57,0,0,1,259.19,389.43Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.34,398.14a12.75,12.75,0,0,1-3.26.43,53.94,53.94,0,0,1-7.93-.11,54.5,54.5,0,0,1-7.84-1.25,12.56,12.56,0,0,1-3.13-1,20.11,20.11,0,0,1,3.24.49c2,.35,4.73.78,7.79,1s5.84.32,7.85.31A18.57,18.57,0,0,1,263.34,398.14Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.51,381.85a14.61,14.61,0,0,0,.48,1.82,6.84,6.84,0,0,0,3.54,3.7l.11.05v.12a11,11,0,0,0,1.13,5.08,9.58,9.58,0,0,0,4.51,4.42l.27.12-.13.25a2.31,2.31,0,0,0,0,2,5.14,5.14,0,0,0,1.42,1.73,18.53,18.53,0,0,0,4.32,2.48,62,62,0,0,0,10.59,3.32l.14,0,.07.12a19.55,19.55,0,0,0,3.25,3.64,10.09,10.09,0,0,0,4.24,2.51,13.5,13.5,0,0,0,3.77.38l3.8.1,7.33.2,13.2.37h.05l15.73,3.21,4.37.94,1.14.27a1.13,1.13,0,0,1,.39.12,1.72,1.72,0,0,1-.4,0l-1.16-.18-4.41-.78-15.78-3h.05l-13.2-.28-7.32-.17-3.81-.09a14.5,14.5,0,0,1-3.94-.42,10.75,10.75,0,0,1-4.52-2.66,19.75,19.75,0,0,1-3.35-3.79l.21.15a60.85,60.85,0,0,1-10.69-3.41,19,19,0,0,1-4.45-2.6,5.69,5.69,0,0,1-1.57-2,2.82,2.82,0,0,1,.06-2.44l.14.37a10.08,10.08,0,0,1-4.72-4.72,11.27,11.27,0,0,1-1.07-5.3l.11.17a6.83,6.83,0,0,1-3.58-4A5,5,0,0,1,233.51,381.85Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,405.79c.08.16-1.86,1.15-4.49,1.5s-4.75-.09-4.72-.26,2.11-.09,4.63-.44S268,405.6,268.07,405.79Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,381.25c0,.19-3.17.46-7.11.61s-7.13.1-7.13-.1,3.17-.46,7.11-.61S275.49,381.05,275.49,381.25Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.51,387.13s-.3.29-1,.4a4.6,4.6,0,0,1-2.88-.64,22.36,22.36,0,0,1-3.37-2.7l-3.94-3.45-7.2-6.19a23.67,23.67,0,0,1-2.92-2.65,20.4,20.4,0,0,1,3.23,2.27c1.93,1.48,4.55,3.6,7.36,6,1.4,1.22,2.72,2.4,3.9,3.49a25.54,25.54,0,0,0,3.19,2.76,4.74,4.74,0,0,0,2.6.8C302.14,387.23,302.49,387.07,302.51,387.13Z",
    style: {
      fill: "#7f6358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19,381.71a2.76,2.76,0,0,1-.39-.43l-1-1.28L258,375.21l-5.48-7.14-3.22-4.22a4.88,4.88,0,0,0-2.16-1.51,5.06,5.06,0,0,0-1.34-.27c-.45,0-1,0-1.44,0l-20-.08-6.07-.08-1.65,0a2.65,2.65,0,0,1-.58-.05,2,2,0,0,1,.58-.05l1.65-.05,6.07-.09,20-.07c.5,0,1,0,1.48,0a5.65,5.65,0,0,1,1.47.3,5.43,5.43,0,0,1,2.38,1.68l3.21,4.25,5.39,7.21c1.49,2,2.71,3.67,3.6,4.89.39.54.7,1,1,1.34A2.13,2.13,0,0,1,263.19,381.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.78,364.89a1.19,1.19,0,1,1-.2,1.69,1.22,1.22,0,0,1,.16-1.65",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.58,239.87l40.68,23.91,7.48,132,9.72,74.68H298.26s1.61-90.89,2.11-118.38c.36-19.27-.16-56.62,6.36-79.59,2.78-9.79,30-22.44,30-22.44C351.64,263.22,368.31,259.29,386.58,239.87Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.16,437.46c0,.14-31.56.26-70.5.26s-70.5-.12-70.5-.26,31.56-.26,70.5-.26S440.16,437.31,440.16,437.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.07,415c11.32,9.49,28.91,14.63,43.39,17.56s29.27,4,43.79,6.66c10.15,1.89,20.8,4.56,30.59,1.26a27,27,0,0,0,17.86-23.07,2.49,2.49,0,0,0-.44-2,2.65,2.65,0,0,0-2.07-.5c-43.71,1.94-90,1.67-133.12.06"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.33,387.64H393.49l.5-53.83,47.14-6.08s.21,54.67.21,72.6c0,21.52-18.6,36.48-34.22,34.18s-115.79-21-115.79-21Z",
    style: {
      fill: "#9b7564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.4,338.91l-54.94,5.71V280.16s5.4-21.78,24.38-20.87S444,280.73,444.4,299.56,444.4,338.91,444.4,338.91Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.54,264.93s-17.61,11.59-22.33,24.38c-4.95,13.41-11.9,56.85-11.9,56.85H303Z",
    style: {
      fill: "#00A6C3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,282.72a14.16,14.16,0,0,1,0,2.35c-.05,1.63-.12,3.79-.2,6.41-.16,5.4-.33,12.87-.31,21.12s.24,15.72.45,21.12c.1,2.62.18,4.78.24,6.41a15.13,15.13,0,0,1,0,2.35,14.28,14.28,0,0,1-.28-2.34c-.14-1.5-.31-3.69-.47-6.39-.33-5.41-.62-12.88-.65-21.15s.22-15.74.52-21.15c.14-2.7.29-4.88.42-6.39A15.22,15.22,0,0,1,389,282.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.66,260.33c0,.14-1.84-.35-4.82-.3a21.43,21.43,0,0,0-18.78,11.52c-1.39,2.63-1.78,4.47-1.91,4.44a4.44,4.44,0,0,1,.22-1.3,17.59,17.59,0,0,1,1.25-3.36,20.76,20.76,0,0,1,19.22-11.8,18.58,18.58,0,0,1,3.57.41A4.26,4.26,0,0,1,416.66,260.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.23,295.29a3.81,3.81,0,0,1,.07.73c0,.56,0,1.25.06,2.09,0,1.81.06,4.43.06,7.67,0,6.48-.1,15.43-.29,25.31s-.38,18.73-.51,25.3c-.06,3.16-.11,5.76-.15,7.67,0,.84-.06,1.53-.08,2.09a2.43,2.43,0,0,1-.07.72,3,3,0,0,1-.07-.72c0-.56,0-1.25-.06-2.09,0-1.81-.06-4.43-.06-7.67,0-6.48.1-15.43.29-25.32s.37-18.73.5-25.29c.07-3.17.12-5.76.16-7.67,0-.84.06-1.53.07-2.09A2.64,2.64,0,0,1,301.23,295.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,316.88a67.87,67.87,0,0,1-8.36.19,67.33,67.33,0,0,1-8.36-.34,67.87,67.87,0,0,1,8.36-.19A64.93,64.93,0,0,1,300.6,316.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.06,302c0,.14-19,.26-42.35.26s-42.37-.12-42.37-.26,19-.26,42.37-.26S388.06,301.83,388.06,302Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.21,293.18a2.43,2.43,0,0,1-.56,0l-1.58-.13-5.8-.5c-4.91-.41-11.69-.86-19.19-1.07s-14.3-.12-19.22,0l-5.83.18-1.58,0a1.94,1.94,0,0,1-.56,0,2.47,2.47,0,0,1,.55-.08l1.58-.14c1.38-.11,3.36-.23,5.83-.35,4.92-.23,11.72-.36,19.24-.16s14.31.72,19.21,1.22c2.45.25,4.43.48,5.79.67l1.57.22A2.17,2.17,0,0,1,443.21,293.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.73,331.37c0,.15-12.41,0-27.7-.36s-27.71-.75-27.7-.89,12.4,0,27.71.37S443.73,331.23,443.73,331.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82,269.89c0,.15-19.58.26-43.73.26s-43.73-.11-43.73-.26,19.58-.26,43.73-.26S393.82,269.75,393.82,269.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.34,342.55c0,.14-19.64.26-43.87.26s-43.87-.12-43.87-.26,19.64-.26,43.87-.26S388.34,342.4,388.34,342.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.64,374.63c0,.14-21.36.26-47.7.26s-47.71-.12-47.71-.26,21.36-.26,47.71-.26S394.64,374.48,394.64,374.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.93,467.13c0,.14-32.21.26-71.93.26s-71.93-.12-71.93-.26,32.2-.26,71.93-.26S442.93,467,442.93,467.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M388.79,345.23c-.64-12.74-.18-24.66-.83-37.39a236.42,236.42,0,0,0-6.1,57c.07,4.55.29,9.18,1.76,13.49s5.54,8,9.7,9.84l.4-43.49C391.85,344.82,390.67,345.14,388.79,345.23Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.08,470.66c0,.14-99,.26-221.07.26s-221.09-.12-221.09-.26,99-.26,221.09-.26S471.08,470.51,471.08,470.66Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileinboxPana);
export default __webpack_public_path__ + "static/media/Mobile inbox-pana.f3408e06bdd04559d7cd5be7a1e25945.svg";
export { ForwardRef as ReactComponent };